import { render } from "./heart.vue?vue&type=template&id=1537bbe8"
import script from "./heart.vue?vue&type=script&lang=js"
export * from "./heart.vue?vue&type=script&lang=js"

import "./heart.vue?vue&type=style&index=0&id=1537bbe8&lang=css"

import exportComponent from "C:\\file_data\\zxh\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__